import React from 'react';
import { Button } from '../components/redesign/ui';
import { Eye, EyeSlash, WarningCircle } from '@phosphor-icons/react';

const INPUT = 'w-full rounded-field border border-paper-border2 bg-paper px-3 py-2.5 text-sm text-ink outline-none focus:border-ink';

export default function LoginView({
  email,
  password,
  error,
  loading,
  showPassword,
  onEmailChange,
  onPasswordChange,
  onTogglePassword,
  onSubmit,
}) {
  return (
    <div className="flex min-h-screen bg-paper font-sans text-ink">
      {/* ── Left column: form ── */}
      <div className="flex flex-1 items-center justify-center p-6 sm:p-10">
        <form onSubmit={onSubmit} className="w-full max-w-[380px] rounded-card border border-paper-border bg-paper-panel p-9 shadow-soft">
          {/* Wordmark */}
          <div className="mb-7">
            <div className="font-serif text-3xl text-ink">Aralsane</div>
            <div className="mt-1 text-sm text-ink-muted">Ticketing &amp; AI Customer Service</div>
          </div>

          <h1 className="font-serif text-2xl text-ink">Welcome back</h1>
          <p className="mb-6 mt-2 text-sm text-ink-muted" dir="auto">
            Sign in to the complaint management portal · تسجيل الدخول
          </p>

          {/* Error banner */}
          {error && (
            <div className="mb-4 flex items-start gap-2 rounded-field border border-status-escalated/30 bg-status-escalated/8 px-3 py-2.5 text-sm text-status-escalated">
              <WarningCircle size={16} weight="fill" className="mt-0.5 flex-none" />
              <span>{error}</span>
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="mb-1 block text-xs text-ink-faint">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => onEmailChange(e.target.value)}
                required
                autoComplete="email"
                placeholder="your@email.com"
                className={INPUT}
              />
            </div>
            <div>
              <label className="mb-1 block text-xs text-ink-faint">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => onPasswordChange(e.target.value)}
                  required
                  autoComplete="current-password"
                  placeholder="••••••••"
                  className={`${INPUT} pr-10`}
                />
                <button
                  type="button"
                  onClick={onTogglePassword}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-faint transition hover:text-ink"
                  title={showPassword ? 'Hide password' : 'Show password'}>
                  {showPassword ? <EyeSlash size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
          </div>

          <Button variant="primary" type="submit" disabled={loading} className="mt-6 w-full justify-center">
            {loading ? 'Signing in…' : 'Sign in'}
          </Button>

          <p className="mt-5 text-center text-xs text-ink-faint">
            Protected internal system · access is logged
          </p>
        </form>
      </div>

      {/* ── Right column: entity-branded dark panel (lg+ only) ── */}
      <div className="hidden w-[44%] flex-col justify-between bg-ink p-11 text-paper lg:flex">
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-paper-border2">
          Aralsane Group
        </div>
        <div>
          <div className="mb-4 font-serif text-3xl leading-snug text-paper">
            One portal for every complaint, across three entities.
          </div>
          <div className="flex gap-5 text-[13px] text-paper-border2">
            <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full bg-entity-abraaj-accent" />Abraaj</span>
            <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full bg-entity-lofat" />Lofat</span>
            <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full bg-entity-regency" />Regency</span>
          </div>
        </div>
        <div className="text-xs text-paper-border2">
          © {new Date().getFullYear()} Aralsane Group · Kuwait
        </div>
      </div>
    </div>
  );
}
